import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    margin-top: 2.5em;

    .layout-html-styled-content {
        div {
            font-family: 'Nunito Sans', sans-serif !important;

            h2, h3, h4, h5, h6 {
                color: rgb(178, 144, 81) !important;

                span {
                    font-size: inherit !important;
                    color: inherit !important;
                }
            }

            h2 {
                font-weight: 700;
                font-family: inherit !important;

                span {
                    font-family: inherit !important;
                }
            }

            h3 {
                font-size: 20px;
                font-weight: 400;
                font-family: inherit !important;
                margin: 0.8em 0;

                span {
                    font-family: inherit !important;
                }
            }

            ul, ol {
                padding: 0;
                font-family: inherit !important;

                li {
                    padding: 0.4em;
                    color: #5c5f66 !important;
                    font-size: 16px;
                    font-family: inherit !important;
                    line-height: 1.7;

                    span {
                        font-family: inherit !important;
                    }
                }
            }

            p {
                margin-bottom: 1em;
                font-weight: 400;
                font-family: inherit !important;
                color: #5c5f66 !important;
                text-align: left !important;

                span {
                    color: #5c5f66 !important;
                    font-family: inherit !important;
                    line-height: 1.7 !important;
                }

                strong {
                    font-weight: 700;
                    color: #5c5f66;
                    font-family: inherit !important;
                }

                a {
                    cursor: pointer;
                    color: rgb(178, 144, 81);
                    font-family: inherit !important;
                    display: inline-block;

                    span {
                        font-family: inherit !important;
                        color: rgb(178, 144, 81) !important;

                        strong {
                            font-weight: 700;
                            font-family: inherit !important;
                            color: inherit;
                        }
                    }

                    &:hover {
                        span {
                            color: rgb(42, 42, 42) !important;
                        }
                    }
                }
            }

            img {
                display: inline-block;
                margin: 1em auto;
            }
        }
    }

    .offer-boxes {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 2em;
        margin: 1em auto 2em auto;
    }

    @media all and (max-width: ${variables.tabletL}) {
        .offer-boxes {
            grid-template-columns: repeat(2, 1fr);
        }
    }

    @media all and (max-width: ${variables.mobileL}) {
        .offer-boxes {
            grid-template-columns: repeat(1, 1fr);
            > * {
                margin: 0 auto;
            }
        }
    }

    @media all and (max-width: ${variables.mobileM}) {}
`;
